import React from 'react';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { BodyText, HeaderText } from '../../../ui';
import { LoginStateOptions } from '../../../consumer/booking/BookingFlow/SignInAndSignUp/InlineSigninAndSignup';

type InlineLoginModalTitleProps = {
  helperText?: string;
  modalState: LoginStateOptions;
};

export const InlineLoginModalTitle: React.FCWithChildren<InlineLoginModalTitleProps> = ({
  helperText,
  modalState,
}) => {
  switch (modalState) {
    case LoginStateOptions.MFA:
      return (
        <Box paddingTop={8} />
      );
    case LoginStateOptions.Login:
      return (
        <Box paddingTop={20}>
          <HeaderText testID="login_signup_modal_header_text" level={1}>
            Log In
          </HeaderText>
          {!!helperText && (
            <Box paddingTop={16}>
              <BodyText testID="login_signup_modal_helper_text" appearance="medium" color={BrandColor.FloraDark}>{helperText}</BodyText>
            </Box>
          )}
        </Box>
      );
    case LoginStateOptions.SignUp:
      return (
        <Box paddingTop={12}>
          <HeaderText testID="login_signup_modal_header_text" level={1}>
            Sign Up
          </HeaderText>
          {!!helperText && (
            <Box paddingTop={16}>
              <BodyText testID="login_signup_modal_helper_text" appearance="medium" color={BrandColor.FloraDark}>{helperText}</BodyText>
            </Box>
          )}
        </Box>
      );
    case LoginStateOptions.Initial:
    default:
      return (
        <Box paddingTop={52}>
          <HeaderText testID="login_signup_modal_header_text" level={1}>
            Log In or Sign Up
          </HeaderText>
          {!!helperText && (
            <Box paddingTop={16}>
              <BodyText testID="login_signup_modal_helper_text" appearance="medium" color={BrandColor.FloraDark}>{helperText}</BodyText>
            </Box>
          )}
        </Box>
      );
  }
};
